var common = {
  'message.error.xml2json': 'XML 转 JSON 出错，请检查 XML 格式是否有误'
};
export { common as default };
